import { Button, Col, Radio, Row } from "antd";
import { ButtonProps } from "antd/lib/button";
import React from "react";
import "./ButtonGroup.Component.less";

interface ButtonGroupComponentProps {
  types: "three" | "two";
  onLeft?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onCenter?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onRight?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  leftChild?: any;
  centerChild?: any;
  rightChild?: any;
  leftProps?: ButtonProps;
  centerProps?: ButtonProps;
  rightProps?: ButtonProps;
  style?: React.CSSProperties;
  className?: string;
  singleCard?: boolean;
}
const ButtonGroupComponent = (props: ButtonGroupComponentProps) => {
  const {
    types,
    onLeft,
    onCenter,
    onRight,
    centerChild = "Skip",
    leftChild = "Previous",
    rightChild = "Next",
    leftProps,
    centerProps,
    rightProps,
    style,
    className,
    singleCard = false,
  } = props;

  // switch(types){
  //     case "two":

  //     case "three":
  // }

  return (
    <>
      <div style={{ marginTop: singleCard ? 0 : "50px" }} />
      <Row
        style={{
          ...style,
        }}
        className={`btn-groups ${className}`}
      >
        <Col xs={types == "three" ? 8 : 12}>
          <Button
            onClick={onLeft}
            children={leftChild}
            type="primary"
            {...leftProps}
            block
            style={{
              borderTopRightRadius: 0,
              borderTopLeftRadius: singleCard ? "" : 0,
              borderBottomRightRadius: 0,
              ...leftProps?.style,
            }}
          />
        </Col>
        <Col xs={types == "three" ? 8 : 0}>
          <Button
            onClick={onCenter}
            children={centerChild}
            {...centerProps}
            block
            style={{ borderRadius: 0, ...centerProps?.style }}
          />
        </Col>
        <Col xs={types == "three" ? 8 : 12}>
          <Button
            onClick={onRight}
            children={rightChild}
            type="primary"
            {...rightProps}
            block
            style={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderTopRightRadius: singleCard ? "" : 0,
              ...rightProps?.style,
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default ButtonGroupComponent;
